module.exports = "<div [id]=\"id\">\n    <div class=\"scr-chart-result\" [ngStyle]=\"scoreNgStyle\">\n        {{score}}\n    </div>\n</div>\n";